import { AnimatePresence, type AnimationProps, motion, useReducedMotion } from "framer-motion";
import React, { useState } from "react";
import { FormattedMessage } from "react-intl";

import FileUpload from "~/components/file_upload";
import { LabelRequiredIndicator } from "~/components/ui/label";

export function PatientNewFiles({
  required,
  isVisible = true,
}: {
  required?: boolean;
  isVisible?: boolean;
}) {
  const [numberOfUploads, setNumberOfUploads] = useState(0);

  return (
    <AnimatePatientNewFilesPresence isVisible={isVisible}>
      <div id="extra-media-block" className="form-body">
        <h4 id="validation-files" className="block" style={{ fontWeight: 900 }}>
          <FormattedMessage id="UPLOAD_FILES" />
          {required ? <LabelRequiredIndicator /> : null}
        </h4>

        {Array.from({ length: numberOfUploads + 1 }).map((_, uploadId) => (
          <FileUpload
            key={`recipe_${uploadId}`}
            id={`recipe_${uploadId}`}
            patient_id={0}
            semantics="recipe"
            onFileUploadEnd={() =>
              setNumberOfUploads((prevNumberOfUploads) => prevNumberOfUploads + 1)
            }
            ariaLabelledBy="validation-files"
          />
        ))}
      </div>
    </AnimatePatientNewFilesPresence>
  );
}

function AnimatePatientNewFilesPresence({
  children,
  isVisible,
}: React.PropsWithChildren<{ isVisible: boolean }>) {
  const shouldReduceMotion = useReducedMotion();

  const animationProps: AnimationProps = {
    initial: { height: 0 },
    animate: { height: "auto", transition: { duration: 0.5 } },
    exit: { height: 0 },
  };

  return (
    <AnimatePresence>
      {isVisible ? (
        <motion.div
          // PatientNewFiles h4 adds a margin-top and padding-top that causes
          // the extra vertical space. Had to remove it from here.
          className="tw-overflow-hidden [&_h4]:tw-mt-0 [&_h4]:tw-pt-0"
          {...(shouldReduceMotion ? {} : animationProps)}
        >
          {children}
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
}
